import React from 'react';
import { Phone, Clock, Mail } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-20 bg-gray-50" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="max-w-4xl mx-auto" data-id="element-45">
          {/* Contact Info */}
          <div data-id="element-46">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-47">
              Get in Touch
            </h2>
            <p className="text-lg text-gray-600 mb-10 text-center" data-id="element-48">
              Ready to start your project? Give us a call or send us a message.
              We'd love to help you create something amazing.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-49">
              <div className="flex items-start" data-id="element-50">
                <div className="flex-shrink-0" data-id="element-51">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-purple-100 text-purple-600" data-id="element-52">
                    <Phone className="h-6 w-6" data-id="element-53" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-54">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-55">Phone</h3>
                  <p className="mt-1 text-gray-600" data-id="element-56">
                    Call us for a quote or questions
                  </p>
                  <a href="tel:9045210580" className="mt-1 block text-lg font-semibold text-gray-900 hover:text-purple-600" data-id="element-57">
                    (904) 521-0580
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-58">
                <div className="flex-shrink-0" data-id="element-59">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-purple-100 text-purple-600" data-id="element-60">
                    <Mail className="h-6 w-6" data-id="element-61" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-62">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-63">Email</h3>
                  <p className="mt-1 text-gray-600" data-id="element-64">
                    Send us a message anytime
                  </p>
                  <a href="mailto:info@teamsntees.com" className="mt-1 block text-lg font-semibold text-gray-900 hover:text-purple-600" data-id="element-65">
                    info@teamsntees.com
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-66">
                <div className="flex-shrink-0" data-id="element-67">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-purple-100 text-purple-600" data-id="element-68">
                    <Clock className="h-6 w-6" data-id="element-69" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-70">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-71">Hours</h3>
                  <div className="mt-1 text-gray-600" data-id="element-72">
                    <p data-id="element-73">Monday – Friday: 9:00 AM – 5:00 PM</p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-74">
                      Closed Saturday & Sunday
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}